const options = {
	responsive: true,
	scales: {
		x: {
			display: false,
		},
		y: {
			position: "left",
			min: -1,
			max: 1,
		},
	},
	plugins: {
		legend: {
			display: false,
		},
		title: {
			display: false,
		},
		zoom: {
			limits: {
				x: {
					min: 0,
				},
				y: {
					min: -1,
					max: 1,
				},
			},
			pan: {
				enabled: true,
				mode: "xy",
				modifierKey: "ctrl",
				threshold: 10,
				speed: 20,
			},
			zoom: {
				drag: {
					enabled: true,
					borderColor: "rgb(54, 162, 235)",
					borderWidth: 1,
					backgroundColor: "rgba(54, 162, 235, 0.3)",
				},
				wheel: {
					enabled: true,
					mode: "xy",
				},
				threshold: 10,
				speed: 20,
				mode: "xy",
			},
		},
	},
	elements: {
		point: {
			radius: 0,
		},
	},
	animation: {
		duration: 0,
	},
	tooltips: {
		enabled: false,
	},
	hover: {
		mode: null,
	},
	spanGaps: true,
	normalized: true,
}

export default options

